import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
@Component({
  selector: 'app-popover-btn',
  encapsulation: ViewEncapsulation.ShadowDom,
  templateUrl: './popover-btn.component.html',
  styleUrls: ['./popover-btn.component.css'],
})
export class PopoverBtnComponent implements OnInit {
  @Input() title: string;
  @Input() text: string;
  @Input() position: string;
  @Input() id: string;
  constructor() {}

  iconQuestion = faQuestionCircle;
  ngOnInit(): void {}
}
